import { render, staticRenderFns } from "./entity-not-found.vue?vue&type=template&id=56eaa552&"
import script from "./entity-not-found.vue?vue&type=script&lang=js&"
export * from "./entity-not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports